import React from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const ImageZoomModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-60"
      onClick={onClose}
    >
      <div className="relative w-100 bg-white rounded-lg shadow-lg outline-none mx-auto my-8 z-60">
        {children}
      </div>
    </div>
  );
};

export default ImageZoomModal;
